<template>
    <div class="site__body-order-entry">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <a href="index.php" class="breadcrumb__item-link">Home</a>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <a href="category-drilldown-1.php" class="breadcrumb__item-link">Return Items</a>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--last">
                                        <a href="category-drilldown-1.php" class="breadcrumb__item-link">Approved Returns</a>
                                    </li>
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>

                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Approved Item Returns</h1>
                        </div>

                        <!--<div class="flex-item-page-info-selected-vehcile">
                                        <div class="flex-container--breadcrumbs-selected-vehicle">
                                        <div class="flex-container--select-vehicle-column">
                                            <div class="vehicles-list__item-name">2018 Chevrolet Silverado 1500 LT</div>
                                            <div class="vehicles-list__item-details-category-display">V8-325 CID 5.3L FLEX FI VIN C-L83</div>
                                        </div>					
                                            <div class="flex-container--select-vehicle-column">
                            <div class="product__tags tags tags--sm">
                            <div class="tags__list tags__list-select-vehicle">                         
                                <button class="mobile-search__vehicle-picker change-vehicle__button" type="button">
                                    <span class="search__button-icon">
                                        <svg width="20" height="20">
                                            <path d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1
        c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2
        C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9
        c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0
        c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0
        C15.5,10.2,14,11.3,14,12z" />
                                        </svg>
                                    </span>
                                <span class="search__button-title">Change Vehicle</span>
                                </button>                                                      
                            </div>
                        </div>
                    </div>
                                        </div>
                                </div>-->
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="container">
                    <div>
                        <div class="widget-form-panel-mobile">
                            <div class="container-form">
                                <div class="container-form-button">
                                    <button type="button" class="btn btn-xs btn-checkout">Add More Items</button>
                                </div>
                            </div>
                        </div>
                        <div class="cart__table cart-table">
                            <table class="cart-table__table">
                                <thead class="cart-table__head">
                                    <tr class="cart-table__row">
                                        <th class="cart-table__column cart-table__column--image">Item #</th>
                                        <th class="cart-table__column cart-table__column--product">Description</th>
                                        <th class="cart-table__column cart-table__column--numeral">Approved QTY</th>
                                        <th class="cart-table__column cart-table__column---order-entry-mfg">Manufacturer</th>
                                        <th class="cart-table__column cart-table__column---order-entry-mfg">Return Reason</th>
                                        <th class="cart-table__column cart-table__column--numeral">Item Credit</th>
                                        <th class="cart-table__column cart-table__column--numeral">Core Credit</th>
                                        <th class="cart-table__column cart-table__column--numeral">Ext Credit</th>
                                        <th class="cart-table__column cart-table__column--remove"><img src="images/spacer.png" width="20px" /></th>
                                    </tr>
                                </thead>
                                <tbody class="cart-table__body">
                                    <tr class="cart-table__row">
                                        <td class="cart-table__column cart-table__column--quantity" data-title="Part">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">PF52</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--product" data-title="Part">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">Oil Filter</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">6</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity" data-title="Part">
                                            <div class="cart-table__column---order-entry-mfg">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">ACDelco</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column---order-entry-mfg">
                                            <div class="text-cart-item-number"><font class="text-cart-item-number"></font></div>
                                            <div class="text-cart-item-manufacturer"><font class="text-cart-item-manufacturer"></font></div>
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">Return to Stock</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">$4.10</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">$0.00</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">$24.60</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--remove">
                                            <svg width="25" height="25" viewBox="0 0 32 32" class="cart-X-svg cart-table__remove">
                                                <path d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
                                            </svg>
                                        </td>
                                    </tr>
                                    <tr class="cart-table__row">
                                        <td class="cart-table__column cart-table__column--quantity" data-title="Part">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">100</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--product" data-title="Part">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">Diesel Fuel Filter</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">1</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity" data-title="Part">
                                            <div class="cart-table__column---order-entry-mfg">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">Baldwin Filters</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column---order-entry-mfg">
                                            <div class="text-cart-item-number"><font class="text-cart-item-number"></font></div>
                                            <div class="text-cart-item-manufacturer"><font class="text-cart-item-manufacturer"></font></div>
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">Return to Stock</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">$7.26</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">$0.00</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--quantity-se cart-table__column--quantity" data-title="Quantity">
                                            <div class="cart-table__quantity input-number--order-entry">
                                                <p class="">
                                                    <strong></strong><br />
                                                    <strong><font class="text-black">$7.26</font></strong>
                                                    <br />
                                                </p>
                                            </div>
                                        </td>
                                        <td class="cart-table__column cart-table__column--remove">
                                            <svg width="25" height="25" viewBox="0 0 32 32" class="cart-X-svg cart-table__remove">
                                                <path d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
                                            </svg>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot class="cart-table__foot">
                                    <tr>
                                        <td colspan="12">
                                            <div class="cart-table__actions">
                                                <div class="form-row">
                                                    <div class="form-group">
                                                        <p>&nbsp;&nbsp;</p>
                                                    </div>
                                                    <div class="form-group col-md-6">
                                                        <label for="checkout-first-name">Email Confirmation</label>
                                                        <input type="text" class="form-control" id="checkout-billing-first-name" placeholder="" />
                                                    </div>
                                                    <div class="form-group col-md-5">
                                                        <label for="checkout-last-name">Reference Number</label>
                                                        <input type="text" class="form-control" id="checkout-billing-last-name" placeholder="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="6">
                                            <div class="cart-table__actions">
                                                <div class="cart-table__update-button cart-table__actions-stock-order-add-to-cart">
                                                    <a class="btn btn-md btn-checkout" href="">Submit Return Request</a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div></div>
                </div>
            </div>
        </div>
        <div class="block-space block-space--layout--divider-order-entry"></div>
    </div>
    <div class="block-space block-space--layout--divider-thin"></div>
    <div class="block-space block-space--layout--divider-XS"></div>
    <br />
    <br />
</template>
